import { filterObject, isTruthy } from '@ardoq/common-helpers';
import { MetamodelViewGraphEdge, MetaModelViewGraphNode } from '@ardoq/graph';
import { has } from 'lodash';
import {
  TraversalBuilderFiltersPerNode,
  TraversalBuilderState,
} from '../types';
import { SetSectionFilterPayload } from './editTraversalActions';
import { filterOptions } from './filterOptions';
import { getTraversals } from './getTraversals';

const getUpdateFilterFlagInMetaData = (
  filters: Record<string, TraversalBuilderFiltersPerNode>
) => {
  return (item: MetamodelViewGraphEdge | MetaModelViewGraphNode) => {
    const metaData = item.getMetadata();
    if (metaData && metaData.hasFilters && !has(filters, item.id)) {
      // @ts-expect-error: typescript has a union type comprehension problem
      item.setMetaData({
        ...metaData,
        hasFilters: false,
      });
    }
  };
};

export const updateFilters = (
  state: TraversalBuilderState
): TraversalBuilderState => {
  const traversals = getTraversals(state, null);
  const localFilterIds = new Set(
    traversals.flatMap(path =>
      path.flatMap(({ sourceFilter, targetFilter, referenceFilter }) =>
        [sourceFilter, targetFilter, referenceFilter].filter(isTruthy)
      )
    )
  );
  const filters = filterObject(state.filters, (_, { localFilterId }) =>
    localFilterIds.has(localFilterId)
  );
  const updateMetaData = getUpdateFilterFlagInMetaData(filters);
  const graphEdges = new Map(state.graphEdges);
  const graphNodes = new Map(state.graphNodes);
  graphEdges.forEach(updateMetaData);
  graphNodes.forEach(updateMetaData);
  return {
    ...state,
    filters,
    graphEdges,
    graphNodes,
  };
};

export const setSectionFilter = (
  state: TraversalBuilderState,
  { filterTerm }: SetSectionFilterPayload
): TraversalBuilderState => {
  const filterTermLower = filterTerm.toLowerCase();
  const filteredOptionsIncoming = filterOptions(
    state.tripleOptions.incoming,
    filterTermLower,
    state.triplesSortAndFiltersState.showOnlyOptionsWithInstanceCounts
  );
  const filteredOptionsOutgoing = filterOptions(
    state.tripleOptions.outgoing,
    filterTermLower,
    state.triplesSortAndFiltersState.showOnlyOptionsWithInstanceCounts
  );

  return {
    ...state,
    filteredTripleOptions: {
      ...state.filteredTripleOptions,
      outgoing: filteredOptionsOutgoing,
      incoming: filteredOptionsIncoming,
    },
    triplesSortAndFiltersState: {
      ...state.triplesSortAndFiltersState,
      filterTerm,
    },
  };
};
